import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

@Component({
  selector: 'app-historical-breakdown-chart',
  templateUrl: './historical-breakdown-chart.component.html',
  styleUrls: ['./historical-breakdown-chart.component.scss']
})
export class HistoricalBreakdownChartComponent implements OnInit {

  @Input() catNames: string[];
  @Input() dates: string[];
  @Input() values: number[];
  @Input() xlabel: string;
  @Input() ylabel: string;

  @Input() width: string = '100%';
  @Input() height: string = '300px';

  showLegend: boolean = true;
  showGraph: boolean = true;

  chart: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  constructor() { }

  ngOnInit(): void {
    let thisComponent = this;
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let months_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    this.chartOptions = {
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      chart: {
        type: 'area',
        backgroundColor: 'rgba(255,255,255,0)'
      },
      xAxis: {
        categories: thisComponent.dates,
        labels: {
          formatter: function () {
            const date = new Date(this.value);
            return months_short[date.getMonth()]+' '+date.getFullYear();
          }
        }
      },
      yAxis: {
        min: 0,
        max: 100,
        labels: {
            format: '{value}%'
        },
        title: {
          text: ''
        }
      },
      tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b><br/>',
        split: true
      },
      plotOptions: {
        area: {
            stacking: 'percent',
            lineColor: '#ffffff',
            lineWidth: 1,
            marker: {
                enabled: false
            },
            accessibility: {
                pointDescriptionFormatter: function (point) {
                    function round(x) {
                        return Math.round(x * 100) / 100;
                    }
                    return (point.index + 1) + ', ' + point.category + ', ' +
                        point.y + ' millions, ' + round(point.percentage) + '%, ' +
                        point.series.name;
                }
            }
        }
      },
      series: thisComponent.catNames.map((name, i) => {
        return {
          name: name,
          data: thisComponent.values.map((elem) => (elem[i])),
          type: undefined
        };
      })
    };

    HC_exporting(Highcharts);

  }

}
